export const adaptCriterio = (criterioData) => {
    return {
        id: criterioData?.idCriterio,
        displayName: criterioData?.nombre,
        name: criterioData?.nombre
    }
}

export const adaptCriterioArray = (
    criterios
) => {
    return structuredClone(criterios?.allCriterio)
        ?.map(criterio => adaptCriterio(criterio));
}